"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _react = _interopRequireDefault(require("react"));
var _HBBannerBase = _interopRequireDefault(require("../HBBanner/HBBannerBase"));
var _CheckCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/CheckCircle24"));
var _excluded = ["actionsTheme"];
var ACTION_THEME_TO_BUTTON_THEME = {
  primary: 'primary',
  secondary: 'secondary-solid-secondary'
};
var SuccessBanner = function SuccessBanner(_ref) {
  var _ref$actionsTheme = _ref.actionsTheme,
    actionsTheme = _ref$actionsTheme === void 0 ? 'primary' : _ref$actionsTheme,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_HBBannerBase["default"], (0, _extends2["default"])({
    icon: _CheckCircle["default"],
    primaryActionTheme: ACTION_THEME_TO_BUTTON_THEME[actionsTheme]
  }, props, {
    actionsTheme: actionsTheme,
    accentLine: _colors["default"].green50,
    background: _colors["default"].green40_08
  }));
};
var _default = exports["default"] = SuccessBanner;
//# sourceMappingURL=SuccessBanner.js.map